/* eslint-disable */
import { toSafeDate } from "utils/dateGuards";

/** All Canadian IANA timezone options for use in Select dropdowns */
export const CANADA_TIMEZONES = [
  { value: "America/Vancouver", label: "Pacific — Vancouver, Victoria (UTC-8 / UTC-7)" },
  { value: "America/Edmonton",  label: "Mountain — Calgary, Edmonton (UTC-7 / UTC-6)" },
  { value: "America/Regina",    label: "Mountain (no DST) — Regina, Saskatoon (UTC-6)" },
  { value: "America/Winnipeg",  label: "Central — Winnipeg (UTC-6 / UTC-5)" },
  { value: "America/Toronto",   label: "Eastern — Toronto, Ottawa (UTC-5 / UTC-4)" },
  { value: "America/Halifax",   label: "Atlantic — Halifax, Moncton (UTC-4 / UTC-3)" },
  { value: "America/St_Johns",  label: "Newfoundland — St. John's (UTC-3:30 / UTC-2:30)" },
];

export const DEFAULT_ORG_TIMEZONE = "America/Toronto";

export const TimeZoneDate = (dateString: any) => {
  const date = toSafeDate(dateString);
  if (!date) return "";
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}-${month}-${year}`;
};
